// Eight badge color pairs, defined per theme in Theme.css (--section-N-bg/-text).
const SECTION_COLORS = Array.from({ length: 8 }, (_, i) => ({
    backgroundColor: `var(--section-${i + 1}-bg)`,
    color: `var(--section-${i + 1}-text)`,
}));

export function sectionColor(section) {
    let hash = 0;
    for (let i = 0; i < section.length; i++) hash = section.charCodeAt(i) + ((hash << 5) - hash);
    return SECTION_COLORS[Math.abs(hash) % SECTION_COLORS.length];
}

// Builds an external link for a similar paper. Prefers PubMed (pmid), falls back
// to OpenAlex (openalexId), and returns null when neither identifier is present
// so the caller can render the title as plain, non-clickable text.
export function paperLink(paper) {
    if (!paper) return null;
    if (paper.pmid != null && paper.pmid !== "") {
        return `https://pubmed.ncbi.nlm.nih.gov/${paper.pmid}`;
    }
    if (paper.openalexId) {
        const value = String(paper.openalexId).trim();
        if (!value) return null;
        return value.startsWith("http") ? value : `https://openalex.org/${value}`;
    }
    return null;
}

export function calculateOverallScore(manuscript) {
    let sum = 0;
    let count = 0
    if (manuscript.noveltyScore != null && manuscript.noveltyScore !== undefined) {
        sum += manuscript.noveltyScore;
        count++;
    }
    if (manuscript.impactScore != null && manuscript.impactScore !== undefined) {
        sum += manuscript.impactScore;
        count++;
    }
    if (manuscript.methodScore != null && manuscript.methodScore !== undefined) {
        sum += manuscript.methodScore;
        count++;
    }

    return sum > 0 && count > 0 ? Math.round(sum / count) : 0;
}